export default __webpack_public_path__ + "static/media/sold-out@3x.a06e5e29.png";